import SendSuccess from './send_success'
import { connect } from 'react-redux'
import { getCampaignSelector } from 'redux/selectors/campaign'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    goalName: campaign.title,
    campaignType: campaign.campaign_type,
    amount: state.send_iframe.amount,
    currency: campaign.currency,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SendSuccess)
